import { inject, Service } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { PermissionsBackendService } from '@core/providers/backend/permissions-backend.service';
import { RolesService } from '@core/providers/backend/roles.service';
import { NavigationService } from '@core/providers/navigation/navigation.service';
import { AuthService } from './auth.service';

@Service()
export class HasAccessToFbiGuard {
  private navigationService = inject(NavigationService);
  private rolesService = inject(RolesService);
  private permissionsBackendService = inject(PermissionsBackendService);
  private authService = inject(AuthService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if (!this.authService.authenticated()) {
      this.navigationService.goToLogin();

      return of(false);
    }
    if (this.rolesService.isAdmin()) {
      return of(true);
    }

    return this.permissionsBackendService.hasAccess$().pipe(
      mergeMap((hasAccess: boolean) => {
        if (!hasAccess) {
          this.navigationService.goToNoAccess();
        }

        return of(hasAccess);
      })
    );
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canActivate(route, state);
  }
}
